var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2B705;}\n\t.st1{fill:#53CBC8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-111.727 -376.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st0",
    d: "M151,380.4c-15,0-27.2,12.2-27.2,27.2c0,0,0,0,0,0c0,1.7,0.2,3.4,0.5,5.1l3.5-2.4 c6.2-4.2,16.2-4.2,22.3,0l3.7,2.5l2,1.4c5.6,3.8,14.6,3.8,20.1,0l1.6-1.1c3-14.7-6.5-29.1-21.2-32.1 C154.7,380.6,152.9,380.4,151,380.4L151,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "st1",
    d: "M166.3,423.8c-3.9,0.1-7.7-1-11-3.1l-5.7-3.9c-6.3-3.9-14.2-3.9-20.5,0l-3.7,2.5 c-0.7,0.5-1.7,0.3-2.2-0.4c-0.5-0.7-0.3-1.7,0.4-2.2l3.7-2.5c7.4-4.6,16.7-4.6,24.1,0l5.7,3.9c5.6,3.4,12.7,3.4,18.3,0l2.2-1.5 c0.7-0.5,1.7-0.3,2.2,0.4c0.5,0.7,0.3,1.7-0.4,2.2l0,0l-2.2,1.5C174,422.8,170.2,423.9,166.3,423.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st1",
    d: "M139.3,435.3v-15.3c0-0.3,0-0.6,0-1c0.1-0.9,0.8-1.5,1.7-1.5c0.9,0,1.6,0.7,1.6,1.5 c0.1,0.5,0.1,1.1,0.1,1.6v30.6c0,1-0.7,1.8-1.7,1.9c0,0,0,0,0,0c-1-0.1-1.7-0.9-1.7-1.9c0,0,0-0.1,0-0.1v-10.2L139.3,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    className: "st1",
    d: "M136.1,427.5v7.6c0,1.3-0.7,2.2-1.7,2.1c-1.1-0.1-1.9-1.1-1.7-2.1c0,0,0,0,0,0v-15.2 c0-1.3,0.8-2.2,1.8-2.2s1.6,0.9,1.6,2.2C136.1,422.4,136.1,425,136.1,427.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    className: "st1",
    d: "M146,427.5v-5.4c0-1.2,0.7-2,1.6-2c1,0,1.8,0.9,1.8,1.9c0,0,0,0,0,0.1c0,3.6,0,7.3,0,10.9 c0.1,1-0.6,1.8-1.5,2c-0.1,0-0.2,0-0.2,0c-1,0-1.7-0.8-1.7-2L146,427.5L146,427.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    className: "st1",
    d: "M126,428.6v-5.4c0-1.2,0.7-2,1.6-2c1,0,1.8,0.9,1.8,1.9c0,0,0,0,0,0.1c0,3.6,0,7.3,0,10.9 c0.1,1-0.6,1.8-1.5,2c-0.1,0-0.1,0-0.2,0c-1,0-1.7-0.8-1.7-2L126,428.6L126,428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    className: "st1",
    d: "M154.3,424.1L154.3,424.1c0.9,0,1.7,0.8,1.7,1.7v2.9c0,0.9-0.8,1.7-1.7,1.7l0,0 c-0.9,0-1.7-0.8-1.7-1.7v-2.9C152.6,424.8,153.4,424.1,154.3,424.1L154.3,424.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    className: "st1",
    d: "M161,426.6L161,426.6c0.9,0,1.7,0.8,1.7,1.7v16.4c0,0.9-0.8,1.7-1.7,1.7l0,0 c-0.9,0-1.7-0.8-1.7-1.7c0,0,0,0,0,0v-16.4C159.3,427.4,160,426.6,161,426.6C161,426.6,161,426.6,161,426.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    className: "st1",
    d: "M167.6,427.3L167.6,427.3c0.9,0,1.7,0.8,1.7,1.7v13.9c0,0.9-0.8,1.7-1.7,1.7l0,0 c-0.9,0-1.7-0.8-1.7-1.7c0,0,0,0,0,0v-13.9C165.9,428,166.7,427.3,167.6,427.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    className: "st1",
    d: "M174.3,425.7L174.3,425.7c0.9,0,1.7,0.8,1.7,1.7v6c0,0.9-0.8,1.7-1.7,1.7l0,0 c-0.9,0-1.7-0.8-1.7-1.7v-6C172.6,426.4,173.4,425.7,174.3,425.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonriver);
export default __webpack_public_path__ + "static/media/moonriver.c3da839ddbce37bcca9b36c7f77286b5.svg";
export { ForwardRef as ReactComponent };